import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Divider, Space } from "antd";

import { Header, Nav, HamburgerMenu, BaseTable } from "./components";

import {
  loginUserCheck,
  logoutUser,
  spareFetchByBrand,
  spareDeleteById,
} from "../redux/actions";

class AdminSpareDetail extends Component {
  constructor() {
    super();
    this.state = {
      brand_title: "",
      brand_id: "",
      selectType: "wall",
      toggleMenu: false,
      isLoading: true,
      columns: [
        {
          title: "Image",
          dataIndex: "img",
          key: "img",
          render: (text) => (
            <img
              src={text}
              style={{ height: "70px", maxWidth: "100px" }}
              alt="product"
            />
          ),
        },
        {
          title: "Name",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "Price",
          dataIndex: "price",
          key: "price",
        },
        {
          title: "Brand",
          dataIndex: "brand",
          key: "brand",
        },
        {
          title: "Type",
          dataIndex: "product_type",
          key: "product_type",
          render: (text) => {
            let type = "";
            if (text === "wall") type = "แอร์ผนัง";
            else if (text === "hang") type = "แอร์แขวน";
            else if (text === "four") type = "แอร์สี่ทิศทาง";
            else if (text === "one_way") type = "แอร์หนึ่งทิศทาง";
            else type = "แอร์เปลือย";
            return type;
          },
          filters: [
            {
              text: "แอร์ผนัง",
              value: "wall",
            },
            {
              text: "แอร์แขวน",
              value: "hang",
            },
            {
              text: "แอร์สี่ทิศทาง",
              value: "four",
            },
            {
              text: "แอร์หนึ่งทิศทาง",
              value: "one_way",
            },
            {
              text: "แอร์เปลือย",
              value: "concealed",
            },
          ],
          onFilter: (value, record) => record.product_type.indexOf(value) === 0,
        },
        {
          title: "Created Date",
          dataIndex: "created_date",
          key: "created_date",
          render: (text) => {
            const d = new Date(Number(text));
            const date =
              d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
            return date;
          },
        },
        {
          title: "Action",
          key: "action",
          render: (_, record) => (
            <Space size="middle" className="table-action">
              <Button
                type="primary"
                className="btn-edit"
                onClick={() =>
                  (window.location = `/admin/editspare?id=${record.id}`)
                }
              >
                แก้ไข
              </Button>
              <Divider type="vertical" />
              <Button
                type="primary"
                danger
                onClick={() => this._onDeleteItem(record)}
              >
                ลบ
              </Button>
            </Space>
          ),
        },
      ],
    };
  }

  componentWillMount() {
    this.props.loginUserCheck();
    const params = this.getParams();
    this.setState({
      brand_id: params.id,
      brand_title: params.title,
      selectType: params.type,
    });
  }

  componentDidMount() {
    this.props.spareFetchByBrand(this.state.brand_id);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.spares) {
      this.setState({ isLoading: false });
    }
  }

  getParams() {
    const searchParams = new URLSearchParams(this.props.location.search);
    return {
      id: searchParams.get("id") || "",
      title: searchParams.get("title") || "",
      type: searchParams.get("type") || "wall",
    };
  }

  _handleMenu() {
    this.setState({ toggleMenu: !this.state.toggleMenu });
  }

  _handleLogout() {
    this.props.logoutUser();
  }

  _onDeleteItem(data) {
    // console.log(data);
    if (window.confirm("Are you sure you want to delete this item?")) {
      const file = decodeURIComponent(data.img.substring(70, 95));
      this.props.spareDeleteById(data, file);
    }
  }

  render() {
    if (!this.props.user) return <div></div>;
    return (
      <div>
        <Header name={this.props.user} logout={() => this._handleLogout()} />
        <div className="admin-productdetail">
          <Nav active="spare" />
          <div
            className={this.state.toggleMenu ? "content moveover" : "content"}
          >
            <div className="content-inner">
              <HamburgerMenu onClick={() => this._handleMenu()} />
              <div className="title">
                <h2>
                  อะไหล่ :{" "}
                  <span className="brandname">{this.state.brand_title}</span>
                </h2>

                <div className="btn-addproduct">
                  <Link
                    to={{
                      pathname: "/admin/addspare",
                      search: `?id=${this.state.brand_id}&title=${this.state.brand_title}&type=${this.state.selectType}`,
                    }}
                    className="add-product"
                  >
                    เพิ่มอะไหล่
                  </Link>
                </div>
              </div>
              <div className="info">
                <BaseTable
                  columns={this.state.columns}
                  datas={this.props.spares ? this.props.spares : []}
                  loading={this.state.isLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, spare, product }) => {
  return {
    user: auth.user,
    spares: spare.spares,
    products: product.products,
  };
};

export default connect(mapStateToProps, {
  loginUserCheck,
  logoutUser,
  spareFetchByBrand,
  spareDeleteById,
})(AdminSpareDetail);
